export const shortUUID = (value: string) => {
  const splitted = value.split('-');

  return splitted[splitted.length - 1];
};
